/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {service as SurveyAnswerPlantQuantityStockTypeService} from "../../../Services/SurveyAnswerPlantQuantityStockTypeService";
import {ServiceDrivenDropDownFieldEditor} from "../../../Models/Core/FieldEditors/ServiceDrivenDropDownFieldEditor";

export const StockTypePicker = ServiceDrivenDropDownFieldEditor(SurveyAnswerPlantQuantityStockTypeService);

export const SurveyAnswerPlantQuantityStockTypeFieldEditor = (props) => {
    return <StockTypePicker
        additionalOptions={[{key: 0, value: '', title: 'Unspecified'}]}
        {...props}
    />;
}
